
export const TGPIN_OK = 'ok'
export const TGPIN_BACK = 'back'
